export default defineNuxtPlugin(() => {    
    return {
        provide: {
            article: ref({}),
            event: ref({})
        }
    }
})
